/**
 * American Surgical product catalog — 10 products, ~124 SKUs total.
 * Sourced from americansurgical.com product pages.
 *
 * Schema:
 *   id           — slug used for testids and routing
 *   name         — display name
 *   sub          — short subtitle
 *   img          — primary product photo (americansurgical.com CDN)
 *   gallery[]    — additional product photos (carousel/thumbnail views)
 *   blurb        — 1-2 sentence elevator pitch
 *   bullets[]    — feature bullets
 *   packaging    — "200 per box…"
 *   madeIn       — origin
 *   badge        — null | "Best Seller" | "Microsurgery" | "New"
 *   skuGroups[]  — { label, columns: [..], rows: [{code, ...}, ...] }
 */
export const ASC_PRODUCTS = [
  {
    id: "ray-cot",
    name: "Ray-Cot®",
    sub: "Standard Rayon Neurosurgical Pattie",
    img: "https://www.americansurgical.com/wp-content/uploads/2023/06/Ray-Cot-NEW23-1024x707.png",
    gallery: [
      "https://www.americansurgical.com/wp-content/uploads/2019/08/ray-cot-neuro-pattie-e1681826862367-1024x701.png",
      "https://www.americansurgical.com/wp-content/uploads/2019/08/ray-cot-cottonoid-e1671485029737-1024x699.png",
    ],
    blurb: "12% greater absorbency, 2× stronger than the leading competitor. Single barium line, smooth precise edges, thinner locator string.",
    bullets: [
      "12% greater absorbency, 2× stronger",
      "Single barium line — superior pliability",
      "Smooth precision-cut edges",
      "X-ray detectable with locator string",
    ],
    packaging: "200 per box (20 pouches of 10 patties)",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: "Best Seller",
    videoId: "u5Q_Cg3cZAY",
    skuGroups: [
      {
        label: "Patties (with locator string)",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "60-02", a: "¼ × ¼",     b: "6 × 6" },
          { code: "60-04", a: "¼ × 3",     b: "6 × 76" },
          { code: "60-05", a: "3⁄8 × 3",   b: "10 × 76" },
          { code: "60-06", a: "½ × ½",     b: "13 × 13" },
          { code: "60-07", a: "½ × 1",     b: "13 × 25" },
          { code: "60-08", a: "½ × 1½",    b: "13 × 38" },
          { code: "60-09", a: "½ × 3",     b: "13 × 76" },
          { code: "60-10", a: "¾ × ¾",     b: "19 × 19" },
          { code: "60-12", a: "1 × 1",     b: "25 × 25" },
          { code: "60-13", a: "1 × 3",     b: "25 × 76" },
          { code: "60-14", a: "1½ × 1½",   b: "38 × 38" },
          { code: "60-15", a: "3 × 3",     b: "76 × 76" },
          { code: "60-16", a: "¼ × 1½",    b: "6 × 38" },
          { code: "60-22", a: "1½ × 3",    b: "38 × 76" },
          { code: "60-29", a: "½ × 2",     b: "13 × 51" },
        ],
      },
      {
        label: "Strips (no locator string)",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "61-01", a: "¼ × 6",   b: "6 × 152" },
          { code: "61-02", a: "½ × 6",   b: "13 × 152" },
          { code: "61-03", a: "¾ × 6",   b: "19 × 152" },
          { code: "61-04", a: "1 × 6",   b: "25 × 152" },
          { code: "61-05", a: "2 × 6",   b: "51 × 152" },
          { code: "61-06", a: "3 × 6",   b: "76 × 152" },
          { code: "61-07", a: "3½ × 6",  b: "89 × 152" },
          { code: "61-08", a: "1½ × 6",  b: "38 × 152" },
        ],
      },
    ],
  },
  {
    id: "delicot",
    name: "Delicot®",
    sub: "Ultra-Thin Microsurgical Pattie",
    img: "https://www.americansurgical.com/wp-content/uploads/2019/08/Delicot-cottonoid-e1671484961996-1024x691.png",
    gallery: [
      "https://www.americansurgical.com/wp-content/uploads/2019/08/Delicot-neuro-pattie-e1681826928500-1024x699.png",
    ],
    blurb: "0.33 mm profile — the thinnest neurosurgical pattie on the market. Designed for skull-base & key-hole microsurgery.",
    bullets: [
      "0.33 mm thinnest profile",
      "Made for micro neurosurgery",
      "Exceptional pliability & maneuvering",
      "X-ray detectable with locator string",
    ],
    packaging: "200 per box (20 pouches of 10 patties) · 63×00: 100/box",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: "Microsurgery",
    videoId: "25BBxOcgBYY",
    skuGroups: [
      {
        label: "Delicot® Patties",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "63×00", a: "5⁄64 × 25⁄32", b: "2 × 20" },
          { code: "63-01", a: "3⁄16 × 5⁄16",  b: "5 × 8" },
          { code: "63-02", a: "3⁄16 × ½",     b: "5 × 13" },
          { code: "63-03", a: "3⁄8 × ½",      b: "10 × 13" },
          { code: "63-04", a: "9⁄16 × 13⁄16", b: "15 × 20" },
          { code: "63-05", a: "5⁄32 × 2",     b: "4 × 50" },
          { code: "63-06", a: "¼ × 2",        b: "6 × 50" },
          { code: "63-07", a: "11⁄32 × 2",    b: "9 × 50" },
          { code: "63-08", a: "½ × 2 3⁄8",    b: "13 × 60" },
          { code: "63-09", a: "13⁄16 × 2 3⁄8", b: "20 × 60" },
          { code: "63-10", a: "1 3⁄16 × 2¾",  b: "30 × 70" },
        ],
      },
    ],
  },
  {
    id: "tapered-delicot",
    name: "Tapered Delicot®",
    sub: "Ultra-Thin Tapered Pattie",
    img: "https://www.americansurgical.com/wp-content/uploads/2021/08/tapered-delicot-new-vertical-1024x758.png",
    gallery: [
      "https://www.americansurgical.com/wp-content/uploads/2023/05/tapered-pattie0522.png",
      "https://www.americansurgical.com/wp-content/uploads/2021/08/tapered-delicot-new-vertical-e1681827718632.png",
    ],
    blurb: "Tapered shape designed for confined operative corridors. Maximizes protection in micro neurosurgery without sacrificing visibility.",
    bullets: [
      "Ultra-thin tapered profile",
      "Made for micro neurosurgery key-hole work",
      "Exceptional pliability — gently hugs neural tissue",
      "X-ray detectable with locator string",
    ],
    packaging: "200 per box (20 pouches of 10 patties)",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: null,
    skuGroups: [
      {
        label: "Tapered Delicot®",
        columns: ["Code", "Size (mm)"],
        rows: [
          { code: "63-07T", a: "4 × 9 × 48" },
          { code: "63-08T", a: "6 × 19 × 51" },
          { code: "63-09T", a: "8 × 19 × 64" },
          { code: "63-12T", a: "8 × 19 × 76" },
          { code: "63-13T", a: "6 × 13 × 9" },
          { code: "63-14T", a: "19 × 25 × 25" },
          { code: "63-15T", a: "19 × 25 × 76" },
        ],
      },
    ],
  },
  {
    id: "telfa",
    name: "Telfa®",
    sub: "Surgical Pattie & Strips",
    img: "https://www.americansurgical.com/wp-content/uploads/2019/08/telfa-strips-e1671484981727-1024x691.png",
    gallery: [
      "https://www.americansurgical.com/wp-content/uploads/2019/08/telfa-strips-counting-card-e1681826895474-1024x699.png",
    ],
    blurb: "Perforated polymer outer + absorbent cotton core. Remarkably low tissue adhesion — ideal for delicate dissection. Absorbs 11× its dry weight.",
    bullets: [
      "Low tissue adhesion + high absorbency",
      "Hybrid Telfa outer / cotton inner",
      "Thinner locator string for visibility",
      "X-ray detectable with locator string",
    ],
    packaging: "200 per box (20 pouches of 10 patties)",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: null,
    videoId: "6NZZxGw4GiM",
    skuGroups: [
      {
        label: "Telfa® Patties",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "80-04", a: "¼ × 3",   b: "6 × 76" },
          { code: "80-05", a: "3⁄8 × 3", b: "10 × 76" },
          { code: "80-06", a: "½ × ½",   b: "13 × 13" },
          { code: "80-08", a: "½ × 1½",  b: "13 × 38" },
          { code: "80-09", a: "½ × 3",   b: "13 × 76" },
          { code: "80-11", a: "¾ × 3",   b: "19 × 76" },
          { code: "80-12", a: "1 × 1",   b: "25 × 25" },
          { code: "80-13", a: "1 × 3",   b: "25 × 76" },
          { code: "80-14", a: "3 × 3",   b: "76 × 76" },
        ],
      },
      {
        label: "Strips (no locator string) + Custom",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "81-06", a: "½ × 6", b: "13 × 152" },
          { code: "81-13", a: "1 × 6", b: "25 × 152" },
          { code: "82-01", a: "Custom Telfa Pack", b: "—" },
        ],
      },
    ],
  },
  {
    id: "americot",
    name: "Americot®",
    sub: "100% U.S.A. Cotton Pattie",
    img: "https://www.americansurgical.com/wp-content/uploads/2019/08/americot-cottonoid-e1681502031620-1024x684.png",
    gallery: [
      "https://www.americansurgical.com/wp-content/uploads/2019/08/americot-neuro-pattie-winding-card-e1681826965534-1024x699.png",
      "https://www.americansurgical.com/wp-content/uploads/2023/06/Americot-NEW23-1024x707.png",
    ],
    blurb: "Highly pliable 100% cotton — absorbs 11× its dry weight. Precision-cut, smooth edges, x-ray detectable.",
    bullets: [
      "100% U.S.A. cotton",
      "Absorbs > 11× dry weight",
      "Single barium line — superior pliability",
      "Precision-cut edges",
    ],
    packaging: "200 per box (20 pouches of 10 patties)",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: null,
    videoId: "rcPJ0eEhSa0",
    skuGroups: [
      {
        label: "Americot® Patties",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "20-01S", a: "¼ × ¼",      b: "6 × 6" },
          { code: "20-04S", a: "½ × ½",      b: "13 × 13" },
          { code: "20-05S", a: "½ × 1",      b: "13 × 25" },
          { code: "20-06S", a: "½ × 1½",     b: "13 × 38" },
          { code: "20-07S", a: "½ × 3",      b: "13 × 76" },
          { code: "20-08S", a: "¾ × ¾",      b: "19 × 19" },
          { code: "20-09S", a: "1 × 1",      b: "25 × 25" },
          { code: "20-10S", a: "1 × 3",      b: "25 × 76" },
          { code: "20-12S", a: "3 × 3",      b: "76 × 76" },
          { code: "20-13S", a: "¾ × 3",      b: "19 × 76" },
          { code: "20-14S", a: "3⁄8 × ¾",    b: "10 × 19" },
          { code: "20-19S", a: "1⁄8 × 1⁄8",  b: "3 × 3" },
          { code: "20-22S", a: "3⁄8 × 3⁄8",  b: "10 × 10" },
          { code: "20-25S", a: "3⁄8 × 1",    b: "10 × 25" },
          { code: "20-26S", a: "3⁄8 × 2",    b: "10 × 51" },
          { code: "20-27S", a: "¾ × 2",      b: "19 × 51" },
          { code: "20-30S", a: "¼ × 1½",     b: "6 × 38" },
          { code: "20-32S", a: "½ × 2",      b: "13 × 51" },
        ],
      },
      {
        label: "Strips (no locator string)",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "21-01", a: "¼ × 6", b: "6 × 152" },
          { code: "21-02", a: "½ × 6", b: "13 × 152" },
          { code: "21-04", a: "1 × 6", b: "25 × 152" },
        ],
      },
    ],
  },
  {
    id: "uniqcot",
    name: "Uniqcot™",
    sub: "0.5 mm Rayon Pattie",
    img: "https://www.americansurgical.com/wp-content/uploads/2022/10/Product-green-copy-1024x707.jpg",
    blurb: "The golden mean between Ray-Cot® and Delicot® — thinner for visibility without sacrificing absorbency.",
    bullets: [
      "0.5 mm — thinner than standard pattie",
      "Improved pliability + visibility",
      "Single barium line",
      "X-ray detectable with locator string",
    ],
    packaging: "200 per box (20 pouches of 10 patties)",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: "New",
    videoId: "bJrDJmkbrK4",
    skuGroups: [
      {
        label: "Uniqcot™ Patties",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "67-02", a: "¼ × ¼",   b: "6 × 6" },
          { code: "67-04", a: "¼ × 3",   b: "6 × 76" },
          { code: "67-06", a: "½ × ½",   b: "13 × 13" },
          { code: "67-07", a: "½ × 1",   b: "13 × 25" },
          { code: "67-08", a: "½ × 1½",  b: "13 × 38" },
          { code: "67-09", a: "½ × 3",   b: "13 × 76" },
          { code: "67-10", a: "¾ × ¾",   b: "19 × 19" },
          { code: "67-12", a: "1 × 1",   b: "25 × 25" },
          { code: "67-13", a: "1 × 3",   b: "25 × 76" },
          { code: "67-29", a: "½ × 2",   b: "13 × 51" },
        ],
      },
      {
        label: "Strips (no locator string)",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "67-81", a: "¼ × 6", b: "6 × 152" },
          { code: "67-82", a: "½ × 6", b: "13 × 152" },
          { code: "67-84", a: "1 × 6", b: "25 × 152" },
        ],
      },
    ],
  },
  {
    id: "atlas-choice-bipolar",
    name: "Atlas Choice™ Bipolar Forceps",
    sub: "Disposable Non-Stick · Solid Silver Tips",
    img: "https://www.americansurgical.com/wp-content/uploads/2023/12/HEROSingle_Use_Bipolar_Forceps_BIP_ATMI_08_Single_Use_liegend_090223_v001_sRGB_72dpi_3840x2160-1024x364.png",
    gallery: [
      "https://www.americansurgical.com/wp-content/uploads/2023/11/ADEOR_Atlas_Single_Use_Bipolar_Forceps_BIP_ATMI_08_Single_Use_liegend_090223_v001_sRGB_72dpi_3840x2160-e1700667377231-1024x373.png",
      "https://www.americansurgical.com/wp-content/uploads/2023/12/Single_Use_Bipolar_Forceps_BIP_ATMI_05_IR_Single_Use_liegend_070223_v001_PSD_CMYK_300dpi_3840x2160-1024x576.png",
      "https://www.americansurgical.com/wp-content/uploads/2023/12/Single_Use_Bipolar_Forceps_BIP_ATMI_08_Single_Use_stehend_130223_v001_PSD_CMYK_300dpi_2160x3840-1024x444.png",
    ],
    blurb: "Solid silver tips, stainless body, dual irrigation options. Heat-transport tech minimizes tissue charring. Micro & macro tips, 8″ and 9″.",
    bullets: [
      "Solid silver precision tips",
      "Low-profile slim tines",
      "Stainless steel body — improved durability",
      "Dual irrigation options",
    ],
    packaging: "Sold individually · See spec for case quantities",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: "New",
    videoId: "kakEfdm9oGY",
    skuGroups: [
      {
        label: "Standard (no irrigation)",
        columns: ["Code", "Length", "Tip"],
        rows: [
          { code: "BIP-ATMI-04", a: "8 in", b: "0.5 mm" },
          { code: "BIP-ATMI-05", a: "8 in", b: "1.0 mm" },
          { code: "BIP-ATMA-03", a: "8 in", b: "1.5 mm" },
          { code: "BIP-ATMA-04", a: "8 in", b: "2.0 mm" },
          { code: "BIP-ATMI-07", a: "9 in", b: "0.5 mm" },
          { code: "BIP-ATMI-08", a: "9 in", b: "1.0 mm" },
          { code: "BIP-ATMI-09", a: "9 in", b: "1.5 mm" },
        ],
      },
      {
        label: "Irrigation versions",
        columns: ["Code", "Length", "Tip"],
        rows: [
          { code: "BIP-ATMI-04-IR", a: "8 in", b: "0.5 mm" },
          { code: "BIP-ATMI-05-IR", a: "8 in", b: "1.0 mm" },
          { code: "BIP-ATMA-03-IR", a: "8 in", b: "1.5 mm" },
          { code: "BIP-ATMA-04-IR", a: "8 in", b: "2.0 mm" },
          { code: "BIP-ATMI-07-IR", a: "9 in", b: "0.5 mm" },
          { code: "BIP-ATMI-08-IR", a: "9 in", b: "1.0 mm" },
          { code: "BIP-ATMI-09-IR", a: "9 in", b: "1.5 mm" },
        ],
      },
    ],
  },
  {
    id: "rhinostop",
    name: "RhinoStop™",
    sub: "Nasal Packing for Epistaxis",
    img: "https://www.americansurgical.com/wp-content/uploads/2025/08/Standard-Type-1.jpg",
    gallery: [
      "https://www.americansurgical.com/wp-content/uploads/2025/08/Sinus-Type.jpg",
      "https://www.americansurgical.com/wp-content/uploads/2025/08/Epistaxis-Type-1.jpg",
    ],
    blurb: "Ultra-clean PVA, proprietary air-foaming technology. Soft, supportive, lint-free — fast absorption with minimal adhesion.",
    bullets: [
      "Fast blood/fluid absorption",
      "Lint- and fiber-free PVA",
      "Ultra-clean — no chemical residue",
      "Patient-comfort soft & supportive",
    ],
    packaging: "Per spec sheet — request from Sterile Mate",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: "New",
    skuGroups: [
      {
        label: "Standard Nasal Packing",
        columns: ["Code", "Size (mm)", "Description"],
        rows: [
          { code: "140-01", a: "45×20×10", b: "With string, no airway tube" },
          { code: "140-02", a: "45×20×15", b: "No string, no airway tube" },
          { code: "140-03", a: "45×20×15", b: "With string, no airway tube" },
          { code: "140-04", a: "45×20×15", b: "With string + airway tube" },
          { code: "140-05", a: "80×20×10", b: "No string, no airway tube" },
          { code: "140-06", a: "80×20×10", b: "With string, no airway tube" },
          { code: "140-07", a: "80×20×15", b: "No string, no airway tube" },
          { code: "140-08", a: "80×20×15", b: "With string, no airway tube" },
          { code: "140-13", a: "80×20×15", b: "With string + airway tube" },
        ],
      },
      {
        label: "Epistaxis Nasal Packing",
        columns: ["Code", "Size (mm)", "Description"],
        rows: [
          { code: "140-09", a: "100×25×15", b: "No string" },
          { code: "140-10", a: "100×25×15", b: "With string" },
        ],
      },
      {
        label: "Sinus Nasal Packing",
        columns: ["Code", "Size (mm)", "Description"],
        rows: [
          { code: "140-11", a: "35×12×6", b: "With string" },
          { code: "140-12", a: "35×12×9", b: "With string" },
        ],
      },
    ],
  },
  {
    id: "comfortpack",
    name: "ComfortPack™",
    sub: "Ophthalmic Eye Pledgets",
    img: "https://www.americansurgical.com/wp-content/uploads/2020/10/comfort-pack.png",
    blurb: "Sterile double-strung cotton pledgets that absorb anesthetic solutions precisely. Multi-use for clinic and OR.",
    bullets: [
      "Needle-free ocular anesthesia",
      "Multi-use clinic & OR",
      "Eliminates waste — cost savings",
      "Patient-preferred comfort",
    ],
    packaging: "See per-SKU UOM",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: null,
    videoId: "wT8f0tyMz60",
    skuGroups: [
      {
        label: "ComfortPack™",
        columns: ["Code", "Size", "UOM"],
        rows: [
          { code: "110-01", a: "ComfortPack",          b: "60/box (30 pouches × 2)" },
          { code: "111-01", a: "5⁄32″ Eye Pledgets only", b: "100/box (20 pouches × 5)" },
          { code: "111-02", a: "7⁄32″ Eye Pledgets only", b: "100/box (20 pouches × 5)" },
        ],
      },
    ],
  },
  {
    id: "xray-cotton-balls",
    name: "X-Ray Detectable Cotton Balls",
    sub: "100% American Cotton — Strung & Non-Strung",
    img: "https://www.americansurgical.com/wp-content/uploads/2021/01/Screen-Shot-2021-01-14-at-4.44.43-PM.png",
    blurb: "Premium strung cotton balls with x-ray detectable marker and double-strung locator string. Reduces gossypiboma risk.",
    bullets: [
      "X-ray detectable marker",
      "Double-strung locator (strung versions)",
      "8 sizes — 3 mm to 51 mm",
      "Eliminates manual cotton tearing",
    ],
    packaging: "100 per box (20 pouches of 5)",
    madeIn: "Salem, Massachusetts, U.S.A.",
    badge: null,
    videoId: "d_tLaQlSCug",
    skuGroups: [
      {
        label: "Strung Cotton Balls",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "30-07", a: "X-Small · 1⁄8", b: "3" },
          { code: "30-00", a: "Small · ¼",    b: "6" },
          { code: "30-03", a: "Medium · ¾",   b: "19" },
          { code: "30-04", a: "Large · 1",    b: "25" },
          { code: "30-05", a: "X-Large · 1¼", b: "32" },
        ],
      },
      {
        label: "Non-Strung Cotton Balls",
        columns: ["Code", "Size (in)", "Size (mm)"],
        rows: [
          { code: "31-07", a: "X-Small · 1⁄8", b: "3" },
          { code: "31-00", a: "Small · ¼",    b: "6" },
        ],
      },
    ],
  },
];
